import React, { Component } from "react";
import { Button, ControlLabel, Modal, Form, FormGroup, InputGroup, ListGroup, ListGroupItem, FormControl, Glyphicon, Grid, Row, Tooltip, OverlayTrigger, Col } from "react-bootstrap";
import uniqueId                  from 'lodash/uniqueId';
import YouTubeThumbnail          from "../../components/YouTubeThumbnail";
import LoaderButton              from "../../components/LoaderButton";
import { Colors }                from "../../utils/Colors";
import ExerciseMatrixCategoryIds from "../../utils/ExerciseMatrixCategoryIds";
import ExerciseCategories        from "../../utils/ExerciseMatrixCategories";

import { invokeGetSearchExercisesListAll,
         invokeGetSearchMatrixExercises } from "../../utils/AwsInvoke";

import "../../css/modal/ModalExerciseMatrix.css";
import "../../css/modal/ModalBasics.css";

const main_categories = [{name:"CORRECTIVES", id: 300},{name:"FOAM ROLL", id: 100},{name:"PREP", id: 200},{name:"SLATE", id: 400},{name:"STRENGTH", id: 500}];

export default class ModalExerciseMatrix extends Component {

    constructor(props) {
        super(props);

        this.state = {
            breadcrumb: [],
            error_msg: "",
            searchTerm: "",
            exerciseList: 0,
            showModalSimple: false,
        };
    }


    async componentDidMount() {
        try {
            var exerc_arr = [];
            exerc_arr.push(main_categories);
            this.setState({
                exercises: main_categories,
                exercise_children: main_categories.length, // total results above
                breadcrumbHistory: exerc_arr,
            });
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount = () => {
        this.setState({
            exercises: null
        })
    }

    getExerciseCategories (id) {
        var exercises = this.searchCategories(id)
        var exerc_results = [];
        var exercise = exercises[0];

        if(exercise != undefined) {
            var lgth = exercise.children.length;

            for(var i=0; i < lgth; i++) {
                var cat_id = exercise.children[i];
                var get_id = this.searchCategories(cat_id)
                var name   = get_id[0].name

                exerc_results.push({name: name, id: cat_id});
            }
        }

        return exerc_results;
    }

    searchCategories (cat_id) {
        var result = ExerciseCategories.filter(function(v, i) {
            return (v.id === cat_id);
        })

        var result2 = ExerciseCategories.filter(function(v, i) {
            return (v.children === cat_id);
        })
        return result;
    }

    handleGetExercises = async (id, action, exerc_name) => {
        var breadcrumb = this.state.breadcrumb;
        var results2   = this.getExerciseCategories(id);
        var exercise   = this.searchCategories(id);
        var breadcrumbHistory = this.state.breadcrumbHistory;
        var new_breadcrumb_arr = [];

        for(var key in results2) {
            new_breadcrumb_arr.push({id:results2[key].id, name:results2[key].name})
        }

        /*if(action === "back") {
                this.setState({
                    exercises: main_categories,
                    //breadcrumb: breadcrumbHistory[0],
                    exercise_children: main_categories.length
                });
        } else */
        if(exercise[0] != undefined && action != "search") {

                var name       = exercise[0].name;
                var children   = exercise[0].children.length;

                //if(action != "back")
                    breadcrumb.push([id, name]);

                if(children === 0)
                    this.getSingleExerciseList(id)
                else
                    this.setState({
                        exercises: results2,
                        breadcrumbHistory: this.state.breadcrumbHistory.concat([new_breadcrumb_arr]),
                        exercise_children: children,
                        breadcrumb: breadcrumb
                    });
        } else {
            //// SEND EXERICSE NAME and ID Back to parent component
            this.props.setExerciseProps(id, exerc_name);
        }
    }


    getSingleExerciseList = async (id) => {
        const results = await invokeGetSearchMatrixExercises(id);

        this.showExercises(results, id);
    }

    showExercises = (results, id, cat_name) => {
        var exerc_results = [];
        var breadcrumb = this.state.breadcrumb;

        for(var key in results.name) {
            var name = results.name[key];
            var id   = results.id[key];
            var yt_id   = results.yt_id[key];

            exerc_results.push({name: name, id: id, yt_id: yt_id});
        }

        // Assign Id and give proper name
        breadcrumb.push([id, cat_name]);

        this.setState({
            breadcrumb: breadcrumb,
            exercises: exerc_results,
            exercise_children: 0
        });
    }

    searchExercises = async () => {
        var search_term    = this.state.searchTerm;
        var number_of_rows = 100;
        var sort_by        = 1; // default sort by Name Asc

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting exerc list
                    searchMsg: ""   // clear search message
                }, function () {
                    //this.getExerciseList();
                })
                return
            }
        }

        const results = await invokeGetSearchExercisesListAll(search_term.toLowerCase(), number_of_rows, sort_by);

        if(results) {
            this.setState({
                exerciseList: 1,
                breadcrumb: [], // reset breadcrumb
                exercises: results,
                searchTerm: search_term,
                //searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchExercises();
    }

    clearSearchField = () => {
        this.setState({
            searchTerm: "", // reset search term if resetting exerc list
        })
    }

    handleGetDetails(evt, uid){
        evt.stopPropagation();
        //var exercise_list = this.state.exerciseList;
        //if(exercise_list)
        // alert("Show detail screen")
    }

    resetSearch () {

        var exerc_arr = [];
        exerc_arr.push(main_categories);

        this.setState({
            exercises: main_categories,
            exercise_children: main_categories.length, // total results above
            breadcrumb: [],
            searchTerm: "",
            exerciseList: 0,
            breadcrumbHistory: exerc_arr,
        })
    }

    showYouTubeVideoModal = (evt, exerc_id, yt_id) => {
        evt.stopPropagation();

        this.props.showYouTubeVideoModal(evt, exerc_id, yt_id);
    }

    selectExercise (i, exercise) {
        var exercise_id   = exercise.id[i-1];
        var exercise_name = exercise.name[i-1];

        this.handleGetExercises(exercise_id, "search", exercise_name);
    }

    renderExerciseDetailsList = (exercises) => {
        var tmp_yt_id = 0;

        if(exercises != null) {
            return [{}].concat(exercises.name).map(
              (exercise, i) => {

                  if(i !== 0) {
                      //if(exercises.yt_id != undefined)
                      tmp_yt_id = exercises.yt_id[i-1];
                  }

                  return (
                        i !== 0 ? (

                                 <ListGroupItem key={uniqueId()}
                                                className = "modalExerciseMatrixList"
                                                onClick={() => this.selectExercise(i, exercises)}>
                                        { /*} <input type="radio"
                                                className="modalExerciseMatrixRadioBtn2"
                                                onClick={evt => this.selectExercise(evt, Math.random())}/> */ }
                                         <span className="modalExerciseMatrixYouTubeThumb"
                                                onClick ={(evt) => this.showYouTubeVideoModal(evt, exercises.id[i-1], exercises.yt_id[i-1], exercise)}
                                                >
                                                     <YouTubeThumbnail yt_id={tmp_yt_id} width={60} />
                                         </span>
                                         &nbsp;
                                         <span className="modalExerciseMatrixExercName">
                                             { exercises.name[i-1] }

                                         </span>
                                </ListGroupItem>
                                )

                        : null
                    ) // end return
                }) // end map
          }
    }

    selectEntireCategory = async (evt, id, cat_name) => {
        evt.stopPropagation();
        this.setState({ error_msg: "Loading category exercises..."})

        var breadcrumb = this.state.breadcrumb;
        // Slate Ids 400-499
        // Strength Ids: 500-799
        // Foam Roll Ids: 100-199
        // Correctives Ids: 300-399
        // Prep Ids: 200-299
        var search_categories = ExerciseMatrixCategoryIds(id);

        const results = await invokeGetSearchMatrixExercises(search_categories);

        /*for(var key in results.name) {
            var name = results.name[key];
            var id   = results.id[key];
            var yt_id   = results.yt_id[key];

            //exerc_results.push({name: name, id: id, yt_id: yt_id});
        }*/

        var breadcrumbHistory = this.state.breadcrumbHistory;
        var new_breadcrumb_arr = [];

        for(var key in results) {
            new_breadcrumb_arr.push({id:results[key].id, name:results[key].name})
        }

        this.setState({
            breadcrumbHistory: this.state.breadcrumbHistory.concat([new_breadcrumb_arr]),
            error_msg: "",
            //breadcrumb: breadcrumb,
            //exercises: exerc_results,
            exercise_children: 0
        });

        this.showExercises(results, id, cat_name);
    }

    renderExerciseList (exercises) {
        var list;
        var exerciseList = this.state.exerciseList;
        var exercise_children = this.state.exercise_children;

        if(exercises && !exerciseList) {

            list = Object.keys(exercises).map( (index, name) => {
                        var youtube = "";
                        var exercise_name = exercises[index].name;
                        var youtube_id    = exercises[index].yt_id
                        var select_category_btn =  <span style={{ float:"right", zIndex: 15000}}
                                                       onClick={(evt) => this.selectEntireCategory(evt, exercises[index].id, exercises[index].name)}>
                                                     <LoaderButton
                                                           //block
                                                           bsSize    = "large"
                                                           type      = "submit"
                                                           className = "modalBasicsBtnSave"
                                                           btncolor  = { Colors.light_gray }
                                                           fontSize  = {20}
                                                           height    = "32px"
                                                           width     = "150px"
                                                           isLoading = {this.state.isLoading}
                                                           text      = "Show Category"
                                                           loadingText = "Loading …"
                                                       />
                                                 </span>

                        if(exercise_children === 0) {
                                select_category_btn = "";
                                youtube = <span className="modalExerciseMatrixYouTubeThumb"
                                                onClick ={(evt) => this.showYouTubeVideoModal(evt, exercises[index].id, youtube_id, exercises[index])}
                                          >
                                                <YouTubeThumbnail yt_id={youtube_id} width={60} />
                                          </span>
                                exercise_name = <span className="modalExerciseMatrixCatName">
                                                      {parseInt(index)+1}. { exercises[index].name }
                                                  </span>
                        }

                        return <ListGroupItem key={uniqueId()}
                                              style={{fontSize: 19, fontWeight: "bold"}}
                                              onClick={() => this.handleGetExercises(exercises[index].id, "next",  exercises[index].name)}>
                                              {youtube}

                                              {exercise_name}
                                              {select_category_btn}

                                    { /*}<input type="radio"
                                           className="modalExerciseMatrixRadioBtn"
                                           //onClick={evt => this.selectExercise(evt)}
                                           onClick={evt => this.handleGetExercise(exercises[index].id)}/> &nbsp; { exercises[index].name }*/ }

                                </ListGroupItem>
                        }
            )

            return <ListGroup style={{height:"403px", overflowY:"auto"}}>
                         { list }
                    </ListGroup>

        } else if(exercises && exerciseList) {
            return <ListGroup style={{height:"350px", overflowY:"auto"}}>
                          { this.renderExerciseDetailsList(exercises) }
                    </ListGroup>
        } else
            return (
                    <ListGroupItem>
                        Loading Exercises...
                    </ListGroupItem>
                )
    }

    gotoBreadcrumbLink = (counter) => {
        var breadcrumbHistory = this.state.breadcrumbHistory;
        var breadcrumb        = this.state.breadcrumb;

        var results = [];
        for(var key in breadcrumbHistory) {
            if(key == counter) {
                var links = breadcrumbHistory[key];

                for(var k = 0; k < links.length; k++)
                    results.push({id: links[k].id, name: links[k].name})
            }
        }

        // Remove element and all elements after index from array
        var del_indices = breadcrumb.length+1;
        breadcrumb.splice(counter, del_indices);
        breadcrumbHistory.splice(counter, del_indices);
        breadcrumbHistory.push(results);

        this.setState({
            exercises: results,
            exercise_children: results.length,
            breadcrumb: breadcrumb,
            breadcrumbHistory: breadcrumbHistory
        });
    }


    render() {
        var arrow, link;
        var breadcrumb = this.state.breadcrumb;
        var trail = [];

        for(var i = 0; i < breadcrumb.length; i++) {
            var id = breadcrumb[i][0];

            arrow = <span key={uniqueId()} style={{padding:"6px"}}> > </span>
            link  = <span key={uniqueId()} style={{padding:"0px", cursor: "pointer", color: Colors.default_blue}}
                          onClick={this.gotoBreadcrumbLink.bind(null, i)}>
                          { breadcrumb[i][1] }
                    </span>

            if(i > 0) {
                trail.push(arrow)
                trail.push(link)
            } else
                trail.push(link)
        }

        var breadcrumb_trail = <span style={{fontSize:19}}>{trail}</span>;

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                className="modalExerciseMatrixModal"
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title" className="fontSize26px">Exercise Categories</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalExerciseMatrixBody">
                      { /*}<FormGroup>
                         <InputGroup>
                           <FormControl key = {uniqueId()}
                                        type="text"
                                        placeholder=""
                                        defaultValue={this.state.searchTerm}
                                        inputRef={ref => { this.searchInput = ref; }}
                                        onKeyPress={this.handleKeyPress}
                                    />

                             <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                   onClick={() => this.clearSearchField()}
                             />
                             <InputGroup.Button>
                               <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.default_blue, color: "white", borderRadiusInputTopRight: "5px !important" }} onClick={() => this.searchExercises()}>Search</Button>
                             </InputGroup.Button>
                         </InputGroup>
                       </FormGroup>*/ }

                  <div>
                      <div className="modalExerciseMatrixFormLabelBody">{ breadcrumb_trail }</div>
                          { this.renderExerciseList(this.state.exercises) }
                  </div>
                  <span className="modalExerciseMatrixErrorMsg">
                        { this.state.error_msg }
                  </span>
                </Modal.Body>
                <Modal.Footer>
                    <span style={{float:"left"}}>

                    </span>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    <Button className="modalBasicsBtnClose" style={{display: "inline-block", width:150}} onClick={() => this.resetSearch()}>Reset Exercises</Button>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalExerciseMatrix.js